import { locale } from "src/environments/locale";




export const httpConfig = {
  baseUrl: '',
  language: locale.language
};
